import { Component, Input } from '@angular/core';
import { IFormattedBakerySchedule } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'ui-deadlines-info',
  templateUrl: './ui-deadlines-info.component.html',
  styleUrls: ['./ui-deadlines-info.component.scss'],
})
export class UiDeadlinesInfoComponent {
  @Input() public deadlines: string | IFormattedBakerySchedule[];

  public get isString() {
    return this.deadlines && typeof this.deadlines === 'string';
  }

  public get deadlineRules(): IFormattedBakerySchedule[] {
    return Array.isArray(this.deadlines) ? this.deadlines : [];
  }
}
